import * as Types from '../../graphql.generated';

export type RegisterUserMutationVariables = Types.Exact<{
    input: Types.RegisterUserInput;
}>;

export type RegisterUserMutation = { __typename?: 'Mutation' } & {
    registerUser?: Types.Maybe<
        { __typename?: 'RegisterUserPayload' } & Pick<
            Types.RegisterUserPayload,
            | 'success'
            | 'pageAfterLoginUrl'
            | 'errorMessage'
            | 'errorCode'
            | 'errorField'
        >
    >;
};

export const RegisterUserDocument = `
    mutation registerUser($input: RegisterUserInput!) {
  registerUser(input: $input) {
    success
    pageAfterLoginUrl
    errorMessage
    errorCode
    errorField
  }
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        registerUser(
            variables: RegisterUserMutationVariables,
            options?: C
        ): Promise<RegisterUserMutation> {
            return requester<
                RegisterUserMutation,
                RegisterUserMutationVariables
            >(RegisterUserDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
